module.exports = __webpack_public_path__ + "static/img/rain.a0fac059.png";